/**
 * Splash Gate Configuration
 * 
 * This file controls the Firebase-authenticated splash page that gates access to the application.
 * Perfect for testing deployments where you want to restrict access to authorized users only.
 * 
 * Security: Users must have a Firebase account to access the app.
 * User Management: Add/remove users through Firebase Console Authentication panel.
 */

const splashGateConfig = {
  // Set to true to enable the splash gate (Firebase login required)
  // Set to false to disable it (anyone can access without login)
  enabled: true,

  // Note: User access is controlled through Firebase Authentication
  // To manage authorized users:
  // 1. Go to Firebase Console → Authentication → Users
  // 2. Add users manually with email/password
  // 3. Delete users to revoke access
  // 
  // Only users added in Firebase Console can access the app when the gate is enabled.
};

export default splashGateConfig;
